import { getUoUParams } from './uou';
import { BIEventIds } from './event-ids';
import { sendBi } from './send-request';
let currentUploadId = '';

// 00000000-0000-0000-0000-000000000000 - 32 digits
function generateId() {
  let id = '';
  while (id.length < 32) {
    id += Math.floor(Math.random() * 10000000000000000);
  }
  return [id.slice(0, 8), id.slice(8, 12), id.slice(12, 16), id.slice(16, 20), id.slice(20, 32)].join('-');
}
export function sendUploadQueueStart() {
  currentUploadId = generateId();
  sendBi('/mg', {
    src: 26,
    evid: BIEventIds.BIEventsIds.uploadQueueStarted,
    upload_queue_id: currentUploadId,
    ...getUoUParams()
  });
}
export function sendUploadQueueFinish(queue) {
  sendBi('/mg', {
    src: 26,
    evid: BIEventIds.BIEventsIds.uploadQueueFinished,
    upload_queue_id: currentUploadId,
    files_count: queue.length,
    ...getUoUParams()
  });
}